import { render } from "./PeopleSection.vue?vue&type=template&id=04f7ceb2&scoped=true"
import script from "./PeopleSection.vue?vue&type=script&lang=js"
export * from "./PeopleSection.vue?vue&type=script&lang=js"

import "./PeopleSection.vue?vue&type=style&index=0&id=04f7ceb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f7ceb2"]])

export default __exports__